module.exports = __webpack_public_path__ + "wsegar-headshot.png?90b556afb61559358b3e01e11e1480e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headshots/wsegar-headshot.png
// module id = 40
// module chunks = 0